import React from 'react'

export default function Footer() {
    return (

        <>
            <div class="d-flex justify-content-center">
                <div class="spinner-grow" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>


            <div className="container">

                <nav className="navbar navbar-expand-lg navbar-dark bg-dark my-3">
                    <div className="container-fluid my-3">
                        <a className="navbar-brand" href="#">made by @nuj...</a>
                    </div>
                </nav>
            </div>
        </>
    )
}
